import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { ERepair } from '../../../../json_query';
import { toggleRepair } from '../../../state/advanced/repair';
import { InlineParam, Row } from '../markup';

export interface IRepairProps {
  repairs: ERepair[];
  onChanged(material: ERepair, value: boolean): void;
}

export const repair: React.StatelessComponent<IRepairProps> = props => (
  <Row title="Ремонт">
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onChanged(ERepair.Cosmetic, value)}
        value={isRepairExists(props.repairs, ERepair.Cosmetic)}
      >
        Косметический
      </ButtonCheckbox>
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onChanged(ERepair.Euro, value)}
        value={isRepairExists(props.repairs, ERepair.Euro)}
      >
        Евроремонт
      </ButtonCheckbox>
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onChanged(ERepair.Design, value)}
        value={isRepairExists(props.repairs, ERepair.Design)}
      >
        Дизайнерский
      </ButtonCheckbox>
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox
        onValueChange={value => props.onChanged(ERepair.Without, value)}
        value={isRepairExists(props.repairs, ERepair.Without)}
      >
        Без ремонта
      </ButtonCheckbox>
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    repairs: (state.filters.jsonQuery.repair && state.filters.jsonQuery.repair.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onChanged: (material: ERepair, value: boolean) => {
      dispatch(toggleRepair(material, value));
    },
  }),
)(repair);

// tslint:disable-next-line:no-shadowed-variable
function isRepairExists(repairs: ERepair[], repair: ERepair): boolean {
  return repairs.indexOf(repair) > -1;
}
